import { fromJS, List } from "immutable";
import {
  AttachmentActionTypes,
  CLOSE_ALL_ATTACHMENTS,
  UPDATE_ATTACHMENT_NUM_PAGES,
  OPEN_ATTACHMENT,
  CLOSE_ATTACHMENT,
  SET_CURRENT_ATTACHMENT_INDEX,
  // Dodajemy nowy typ akcji – pamiętaj, aby zdefiniować go również w plikach akcji
  SET_ALL_DOCUMENTS_SAVED,
  SET_ACTIVE_HIGHLIGHT,
} from "../../action-types/Attachments";

import { ImmutableMap } from "src/helpers/ImmutableHelpers";

export interface AttachmentsState extends ImmutableMap<any> {
  openAttachments: List<any>;
  currentAttachmentIndex: number;
  // Nowe pole – informacja, czy wszystkie dokumenty zostały zapisane
  allDocumentsSaved: boolean;
  activeHighlight: string | null;
}

const initialState: AttachmentsState = fromJS({
  openAttachments: [],
  currentAttachmentIndex: -1,
  // Ustawiamy domyślnie, że dokumenty nie są zapisane
  allDocumentsSaved: false,
  activeHighlight: null,
});

const attachmentsReducer = (
  state = initialState,
  action: AttachmentActionTypes
): AttachmentsState => {
  switch (action.type) {
    case OPEN_ATTACHMENT: {
      const attachment = action.payload;
      const openAttachments = state.get("openAttachments").toJS();
      const isAlreadyOpen = openAttachments.some(
        (att: any) => (att.id || att.location) === (attachment.id || attachment.location)
      );

      let updatedAttachments = openAttachments;
      let currentAttachmentIndex = state.get("currentAttachmentIndex");

      if (!isAlreadyOpen) {
        updatedAttachments = [...openAttachments, attachment];
        currentAttachmentIndex = updatedAttachments.length - 1;
      } else {
        currentAttachmentIndex = openAttachments.findIndex(
          (att: any) => (att.id || att.location) === (attachment.id || attachment.location)
        );
      }

      return state
        .set("openAttachments", fromJS(updatedAttachments))
        .set("currentAttachmentIndex", currentAttachmentIndex);
    }

    case CLOSE_ATTACHMENT: {
      const attachmentId = action.payload;
      const openAttachments = state.get("openAttachments").toJS();

      const updatedAttachments = openAttachments.filter(
        (att: any) => (att.id || att.location) !== attachmentId
      );

      let currentAttachmentIndex = state.get("currentAttachmentIndex");

      if (updatedAttachments.length === 0) {
        currentAttachmentIndex = -1;
      } else if (currentAttachmentIndex >= updatedAttachments.length) {
        currentAttachmentIndex = updatedAttachments.length - 1;
      }

      return state
        .set("openAttachments", fromJS(updatedAttachments))
        .set("currentAttachmentIndex", currentAttachmentIndex);
    }

    case SET_CURRENT_ATTACHMENT_INDEX:
      return state.set("currentAttachmentIndex", action.payload);

    // Dodajemy nową akcję – ustawienie flagi, czy wszystkie dokumenty są zapisane
    case SET_ALL_DOCUMENTS_SAVED: {
      return state.set("allDocumentsSaved", action.payload);
    }

    case SET_ACTIVE_HIGHLIGHT:
      return state.set("activeHighlight", action.payload);

    case UPDATE_ATTACHMENT_NUM_PAGES: {
      const { attachmentId, numPages } = action.payload;
      const openAttachments = state.get("openAttachments").toJS();

      const updatedAttachments = openAttachments.map((att: any) => {
        if ((att.id || att.location) === attachmentId) {
          return { ...att, numPages };
        }
        return att;
      });

      return state.set("openAttachments", fromJS(updatedAttachments));
    }

    case CLOSE_ALL_ATTACHMENTS: {
      return state
        .set("openAttachments", fromJS([]))
        .set("currentAttachmentIndex", -1);
    }

    default:
      return state;
  }
};

export default attachmentsReducer;
